import { gql } from '@/store/helpers/axios.js'
import { merge, isEmpty } from 'lodash'

export default {
  async GET_EVENTS ({ commit }) {
    const query = `query events (
      $where: CrmEventFilterInput
      $order: [CrmEventSortInput!]
    ) {
      response: events (where:$where order: $order) {
        field_001
        anzeigedatum
        sortierdatum
        course_no
        eventlisttitleEN
      }
    }`

    const variables = {
      order: {
        sortierdatum: 'DESC'
      },
      where: {
        event_art_id: { eq: '2' },
        eventpoolIDId: { neq: null },
        or: [{ archivstatusId: { eq: null } }, { archivstatusId: { neq: 1 } }]
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_EVENTS', data.data.response)
    }

    return data
  },
  async GET_ADDRESS_BY_ID ({ commit }, addressId) {
    const query = `query cRMAddress ($id: Int!) {
      response: cRMAddress (field_001: $id) {
        field_001
        permalink
        profiles (where: { profiltypId: { eq: 2 } }) {
          field_001
          profiltypId
          cRMFundingProfileV2s {
            field_001
            datum
            closingdate
            comment
            moneyinCHF
            statusId
            investmentsStage
            investmentsTypeId
            cRMFundingJOINProfilProfileV2s{
              field_001
              profil_idId
              startupFundingID
              profile {
                field_001
                cRM_Adress_id
                cRMAddress {
                  field_001
                  company
                }
              }
            }
          }
        }
      }
    }`

    const variables = {
      id: Number(addressId)
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_BESTELLUNGEN_PAGINATION ({ commit }, { gqlOptions }) {
    const query = `query cRMAnmeldungBestellungensPagination (
        $order: [CRMAnmeldungBestellungSortInput!],
        $where: CRMAnmeldungBestellungFilterInput,
        $take: Int,
        $skip: Int
      ) {
          response: cRMAnmeldungBestellungensPagination (order: $order, where: $where, take: $take, skip: $skip) {
          items {
            field_001
            unicSession
            bestelldatum
            casequality
            sEMINARCasequality {
                field_001
                casequality
                laufnummer
              }
            eventSignupAffirmIDId
            eventSignupFunkionIDId
            vENTURELAB_internal_comment
            cRMAddress {
              field_001
              company
              firstname
              lastname
              emailB1
              mobileB
              phoneB
              internetB
              cityB
              countryBId
              startupPhaseId
              incorporationDate
              permalink
              zipB
              tradeRegisterNr
              facebookB
              linkedInB
              twitterB
              instagramB
              similarwebB
              alexaB
              streetP
              zipP
              cityP
              countryPId
              mobileP
              phoneP
              emailP1
              emailP2
              facebookP
              linkedInP
              twitterP
              birthday
              position
              streetB
              emailB2
              sUTkrTradeRegUID
              unispinoffId
              technologyId
              universityFacultyIDId
              vKacademiclinkId
              legalFormId
              salutationId
              languageId
              educationId
              kantonId
              priovlabId
              prioXMasId,
              vKCaseStatus
              cRMAdresseJOINRolles (where: { rolle_id: { eq: 26 } }) {
                field_001
                rolle_id
                crm_adress_id
              }
              cRMUniFaculty {
                field_001
                departementFaculty
                universityIDId
              }
              profiles (where: { profiltypId: { eq: 2 } }) {
                field_001
                profiltypId
                oneLiner_en
                vleadersAchievements
                description_open_en
                pEOPLEFemaleFounders
                pEOPLEMaleFounders
                totalEmployee
                changeDate
                turnOver
                ownedCopyrights
                ownedTrademarks
                pendingPatents
                grantedPatents
                peopleEPFLFac
                peopleEPFLLab
                peopleEPFLProf
                cRMFundingProfileV2s {
                  field_001
                  datum
                  closingdate
                  comment
                  moneyinCHF
                  statusId
                  investmentsStage
                  investmentsTypeId
                  cRMFundingJOINProfilProfileV2s{
                    field_001
                    profil_idId
                    startupFundingID
                    profile {
                      field_001
                      cRM_Adress_id
                      cRMAddress {
                        field_001
                        company
                      }
                    }
                  }
                }
                pROFILProfilJOINCategories {
                  field_001
                  kategorie_idId
                  pROFILCategory {
                    field_001
                    kategorieDE
                  }
                }
                pROFILUntersttzungszuweisungs {
                  field_001
                  untersttzungId
                }
                pROFILProfilJOINReportingGroups{
                  field_001
                  profil_id
                  pROFILReportingGroup{
                    field_001
                    reportingGroups
                  }
                }
              }
            }
            vLABEvaluations {
              field_001
              comment
              cRMMitarbeiter {
                field_001
                vorname
                nachname
              }
              sEMINARCasequality {
                casequality
                field_001
                laufnummer
              }
            }
          }
          totalCount
        }
      }`

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        eventID: { eq: gqlOptions.eventId }
      }
    }

    if (!isEmpty(gqlOptions.order)) {
      variables.order = {}
    }

    const combinedVariables = merge(variables, gqlOptions)

    const { data } = await gql({ query, variables: combinedVariables })

    return data
  },
  async GET_BESTELLUNGEN_PAGINATION_V2 ({ commit, dispatch }, { options }) {
    const gqlOptions = options.gqlOptions
    const query = options.completeQuery

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        eventID: { eq: gqlOptions.eventId }
      }
    }

    if (!isEmpty(gqlOptions.order)) {
      variables.order = {}
    }

    const combinedVariables = merge(variables, gqlOptions)

    const { data } = await gql({ query, variables: combinedVariables })

    // load profiles seperately, because of performance issues when the query is too large and complex.
    if (options.isProfileVisible) {
      if (data.data.response?.items) {
        const itemsData = data.data.response.items
        const batchSize = 100
        let index = 0

        while (index < itemsData.length) {
          const batch = itemsData.slice(index, index + batchSize)
          const crmAddressIds = []
          batch.map(item => {
            if (item.cRMAddress?.field_001) {
              crmAddressIds.push(item.cRMAddress.field_001)
            }
          })

          const profileData = await dispatch('GET_PROFILES_BY_BESTELLUNGEN', { profilesQuery: options.profilesQuery, crmAddressIds })

          const mapListProfileData = new Map(profileData.data.response.map(item => [item.cRM_Adress_id, item]))

          data.data.response.items.forEach(item1 => {
            if (item1.cRMAddress) {
              item1.cRMAddress.profiles = item1.cRMAddress.profiles || []

              const field001 = item1.cRMAddress.field_001
              if (mapListProfileData.has(field001)) {
                const matchingItem2 = mapListProfileData.get(field001)
                item1.cRMAddress.profiles.push(matchingItem2)
              }
            }
          })

          index += batchSize
        }
      }

      return data
    }

    return data
  },

  async GET_PROFILES_BY_BESTELLUNGEN ({ commit }, options) {
    const query = options.profilesQuery

    const variables = {
      crmAdressIds: options.crmAddressIds
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async GET_EVENT_BY_ID ({ commit }, { id }) {
    const query = `query event ($id: Int!) {
      response: event (field_001: $id) {
        eventlisttitleEN
        anzeigedatum
        sortierdatum
        course_no
        eventpool {
          field_001
          thema_en
        }
      }
    }`

    const variables = {
      id: Number(id)
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_BESTELLUNGEN', data.data.response)
    }

    return data
  },
  async GET_SAVED_EVENTDATA_BY_ADDRESSID ({ commit }, { id }) {
    const query = `query cRMAddress ($id: Int!) {
      response: cRMAddress (field_001: $id) {
          field_001
          sUTkrTradeRegUID
      }
    }`

    const variables = {
      id: Number(id)
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_ADDRESS ({ commit }, { id, formData }) {
    const {
      field_001, /* eslint-disable-line */
      company,
      firstname,
      lastname,
      emailB1,
      mobileB,
      phoneB,
      internetB,
      cityB,
      countryBId,
      startupPhaseId,
      incorporationDate,
      permalink,
      zipB,
      tradeRegisterNr,
      facebookB,
      linkedInB,
      twitterB,
      instagramB,
      similarwebB,
      alexaB,
      streetP,
      zipP,
      cityP,
      countryPId,
      mobileP,
      phoneP,
      emailP1,
      emailP2,
      facebookP,
      linkedInP,
      twitterP,
      birthday,
      position,
      streetB,
      emailB2,
      unispinoffId,
      technologyId,
      universityFacultyIDId,
      vKacademiclinkId,
      legalFormId,
      salutationId,
      languageId,
      educationId,
      kantonId,
      priovlabId,
      prioXMasId,
      sUTkrTradeRegUID,
      vKCaseStatus
    } = formData
    const query = `mutation updateCRMAddress($input: UpdateCRMAddressInput!) {
      updateCRMAddress(input: $input) {
        cRMAddress {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        company,
        firstname,
        lastname,
        emailB1,
        mobileB,
        phoneB,
        internetB,
        cityB,
        countryBId,
        startupPhaseId,
        incorporationDate,
        permalink,
        zipB,
        tradeRegisterNr,
        facebookB,
        linkedInB,
        twitterB,
        instagramB,
        similarwebB,
        alexaB,
        streetP,
        zipP,
        cityP,
        countryPId,
        mobileP,
        phoneP,
        emailP1,
        emailP2,
        facebookP,
        linkedInP,
        twitterP,
        birthday,
        position,
        streetB,
        emailB2,
        unispinoffId,
        technologyId,
        universityFacultyIDId,
        vKacademiclinkId,
        legalFormId,
        salutationId,
        languageId,
        educationId,
        kantonId,
        priovlabId,
        prioXMasId,
        sUTkrTradeRegUID,
        vKCaseStatus
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_PROFILE ({ commit }, { formData }) {
    const {
      field_001, /* eslint-disable-line */
      oneLiner_en, /* eslint-disable-line */
      description_open_en, /* eslint-disable-line */
      pEOPLEFemaleFounders,
      pEOPLEMaleFounders,
      peopleEPFLFac,
      peopleEPFLLab,
      peopleEPFLProf
    } = formData

    const query = `mutation updateProfile($input: UpdateProfileInput!) {
      updateProfile(input: $input) {
        profile {
          field_001
          oneLiner_en
          description_open_en
          pEOPLEFemaleFounders,
          pEOPLEMaleFounders,
          peopleEPFLFac,
          peopleEPFLLab,
          peopleEPFLProf
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        oneLiner_en,
        description_open_en,
        pEOPLEFemaleFounders: Number(pEOPLEFemaleFounders),
        pEOPLEMaleFounders: Number(pEOPLEMaleFounders),
        peopleEPFLFac,
        peopleEPFLLab,
        peopleEPFLProf
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_BESTELLUNGEN ({ commit }, { formData }) {
    const {
      field_001, /* eslint-disable-line */
      casequality,
      eventSignupAffirmIDId,
      eventSignupFunkionIDId,
      vENTURELAB_internal_comment /* eslint-disable-line */
    } = formData

    const query = `mutation updateCRMAnmeldungBestellungen(
      $input: UpdateCRMAnmeldungBestellungenInput!
    ) {
      updateCRMAnmeldungBestellungen(input: $input) {
        cRMAnmeldungBestellung {
          field_001
          casequality
          eventSignupAffirmIDId
          eventSignupFunkionIDId
          vENTURELAB_internal_comment
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        casequality,
        eventSignupAffirmIDId,
        eventSignupFunkionIDId,
        vENTURELAB_internal_comment
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_EVALUATIONS ({ commit }, bestellungId) {
    const query = `query vLABEvaluations (
      $where: VLABEvaluationFilterInput
      $order: [VLABEvaluationSortInput!]
    ) {
      response: vLABEvaluations (where: $where, order: $order) {
        field_001
        datum
        comment
        mitarbeiter_id
        cRMMitarbeiter {
          field_001
          vorname
          nachname
        }
        sEMINARCasequality {
          casequality
          field_001
        }
      }
    }`

    const variables = {
      where: {
        cRM_Anmeldung_Bestellung_id: { eq: bestellungId }
      },
      order: {
        field_001: 'DESC'
      }
    }

    const { data } = await gql({ query, variables })

    return data.data.response
  },
  async UPDATE_EVALUATION ({ commit }, { formData }) {
    const {
      id,
      comment,
      evulationId,
      bestellungId
    } = formData

    const query = `mutation updateVLABEvaluation ($input: UpdateVLABEvaluationInput) {
      updateVLABEvaluation(input: $input) {
        vLABEvaluation {
          field_001
          comment
        }
      }
    }`

    const variables = {
      input: {
        field_001: id,
        comment,
        evaluation_id: evulationId,
        cRM_Anmeldung_Bestellung_id: bestellungId,
        datum: new Date().toISOString()
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async CREATE_EVALUATION ({ commit }, { formData }) {
    const {
      comment,
      evulationId,
      bestellungId
    } = formData

    const query = `mutation createVLABEvaluation ($input: CreateVLABEvaluationInput) {
      createVLABEvaluation(input: $input) {
        vLABEvaluation {
          field_001
          comment
        }
      }
    }`

    const variables = {
      input: {
        comment,
        evaluation_id: evulationId,
        cRM_Anmeldung_Bestellung_id: bestellungId,
        datum: new Date().toISOString()
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_EVENTS_BY_REPORTINGGROUP ({ commit }, gqlOptionsFilter) {
    const {
      gqlOptions,
      rgId
    } = gqlOptionsFilter
    const query = `query pROFILProfilJOINReportingGroupsPagination (
        $order: [PROFILProfilJOINReportingGroupSortInput!],
        $where: PROFILProfilJOINReportingGroupFilterInput,
        $take: Int,
        $skip: Int
      ) {
          response: pROFILProfilJOINReportingGroupsPagination (order: $order, where: $where, take: $take, skip: $skip) {
          items {
              field_001
              profil_id
              reportingGroupIDId
              profile {
                field_001
                profiltypId
                oneLiner_en
                vleadersAchievements
                description_open_en
                pEOPLEFemaleFounders
                pEOPLEMaleFounders
                totalEmployee
                changeDate
                turnOver
                ownedCopyrights
                ownedTrademarks
                pendingPatents
                grantedPatents
                peopleEPFLFac
                peopleEPFLLab
                peopleEPFLProf
                cRMFundingProfileV2s {
                  field_001
                  datum
                  closingdate
                  comment
                  moneyinCHF
                  statusId
                  investmentsStage
                  investmentsTypeId
                }
                cRMAddress {
                  field_001
                  company
                  firstname
                  lastname
                  emailB1
                  mobileB
                  phoneB
                  internetB
                  cityB
                  countryBId
                  startupPhaseId
                  incorporationDate
                  permalink
                  zipB
                  tradeRegisterNr
                  facebookB
                  linkedInB
                  twitterB
                  instagramB
                  similarwebB
                  alexaB
                  streetP
                  zipP
                  cityP
                  countryPId
                  mobileP
                  phoneP
                  emailP1
                  emailP2
                  facebookP
                  linkedInP
                  twitterP
                  birthday
                  position
                  streetB
                  emailB2
                  sUTkrTradeRegUID
                  unispinoffId
                  technologyId
                  universityFacultyIDId
                  vKacademiclinkId
                  legalFormId
                  salutationId
                  languageId
                  educationId
                  kantonId
                  priovlabId
                  prioXMasId,
                  vKCaseStatus
                  cRMAdresseJOINRolles (where: { rolle_id: { eq: 26 } }) {
                    field_001
                    rolle_id
                    crm_adress_id
                  }
                  cRMUniFaculty {
                    field_001
                    departementFaculty
                    universityIDId
                  }
                }
              }
            }
          totalCount
        }
      }`

    const variables = {
      where: {
        profile: { profiltypId: { eq: 2 } },
        reportingGroupIDId: { eq: rgId }
      }
    }

    if (!isEmpty(gqlOptions.order)) {
      variables.order = {}
    }

    const combinedVariables = merge(variables, gqlOptions)

    const { data } = await gql({ query, variables: combinedVariables })

    return data
}
}
